import { TFindingState, TFindingStatus, TReviewSeverity } from '../types';

export type TFindingFilters = {
  severity?: TReviewSeverity;
  status?: TFindingStatus;
  category?: string;
  document?: string;
  basisId?: string;
};

export const EMPTY_FINDING_FILTERS: TFindingFilters = {};

export const hasActiveFilters = (filters: TFindingFilters): boolean =>
  Object.values(filters).some((value) => Boolean(value));

export const filterFindings = (findings: TFindingState[], filters: TFindingFilters): TFindingState[] =>
  findings.filter((finding) => {
    if (filters.severity && finding.severity !== filters.severity) return false;
    if (filters.status && finding.status !== filters.status) return false;
    if (filters.category && finding.category !== filters.category) return false;
    if (filters.document && !(finding.affectedDocuments ?? []).some((document) => document.name === filters.document))
      return false;
    if (filters.basisId && !(finding.reviewBasis ?? []).some((basis) => basis.id === filters.basisId)) return false;
    return true;
  });

const SEVERITY_WEIGHT: Record<TReviewSeverity, number> = { major: 0, minor: 1, needsReview: 2 };
const STATUS_WEIGHT: Record<TFindingStatus, number> = { unresolved: 0, assigned: 1, dismissed: 2, resolved: 3 };

// Open findings first, most severe first, so the list opens on what needs a decision.
export const sortFindings = (findings: TFindingState[]): TFindingState[] =>
  [...findings].sort(
    (a, b) =>
      STATUS_WEIGHT[a.status] - STATUS_WEIGHT[b.status] || SEVERITY_WEIGHT[a.severity] - SEVERITY_WEIGHT[b.severity]
  );
